<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <DialogStatus ref="dlgStatus"></DialogStatus>
    <main-toolbar></main-toolbar>
    <v-container>
    <FileDialog ref="fileDialog" :categories="categories" @close="onCloseFileDialog"></FileDialog>
    <v-layout row justify-center>
      <v-flex xs11 sm10 md9 lg9>
    <v-card class="surfAndScanborder"  flat>
        <v-card-text class="display-1 font-weight-light mb-3">
Scan bearbeiten
        </v-card-text>
      <v-layout row wrap justify-space-around>
        <v-flex xs11 sm11 md4 lg4>
          <v-btn outline round block color="#3c9eca" @click="backPage()" class="text-none mb-4 mt-4">Seite(n) hinzufügen</v-btn>
        </v-flex>
        <v-flex xs11 sm11 md4 lg4>
          <v-btn outline round block color="primary" @click="startNewScan()" class="text-none mb-4 mt-4">Neuer Scan</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center class="hidden-sm-and-down">
        <v-card class="mb-3 mt-5">
          <Container @drop="onDrop" orientation="horizontal" behaviour="contain">
            <Draggable v-for="item in layout" :key="item.id">
              <div class="draggable-item-horizontal ma-3 mb-0">
                <!--<v-badge color="red">
                  <template v-slot:badge>
                    <v-icon
                      color="white"
                      medium
                      @click="deleteItem(item)"
                      style="font-size: 23px;"
                    >
                      clear
                    </v-icon>
                  </template>
                </v-badge> -->
                  <img class="img-md me-img-in-box" v-if="item.imageUrl" v-bind:src="item.imageUrl"
                       :style="'-webkit-user-drag: none;cursor: move;transform: rotate(' + (item.rotate) + 'deg);'" onerror="" v-bind:alt="item.name">
              </div>
              <v-btn flat large icon color="#3271b3" @click="rotateItem(item)">
                <v-icon>loop</v-icon>
              </v-btn>
              <v-btn flat large icon color="red" @click="deleteItem(item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </Draggable>
          </Container>
        </v-card>
      </v-layout>
      <v-layout row wrap justify-center class="hidden-md-and-up">
        <v-card class="mb-3">
          <Container @drop="onDrop" orientation="vertical" behaviour="contain">
            <Draggable v-for="item in layout" :key="item.id">
              <div class="draggable-item-vertical ma-5 mb-0">
                <!--<v-badge color="red">
                  <template v-slot:badge>
                    <v-icon
                      color="white"
                      medium
                      @click="deleteItem(item)"
                      style="font-size: 23px;"
                    >
                      clear
                    </v-icon>
                  </template>
                </v-badge>-->
                  <img class="img-md me-img-in-box" v-if="item.imageUrl" v-bind:src="item.imageUrl"
                       :style="'-webkit-user-drag: none;cursor: move;transform: rotate(' + (item.rotate) + 'deg);'"  onerror="" v-bind:alt="item.name">
              </div>
              <v-btn flat large icon color="#3271b3" @click="rotateItem(item)">
                <v-icon>loop</v-icon>
              </v-btn>
              <v-btn flat large icon color="red" @click="deleteItem(item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </Draggable>
          </Container>
        </v-card>
      </v-layout>
      <v-card-text class="title font-weight-light mb-3">
        Anordnen der Seite per Drag&Drop möglich
      </v-card-text>
      <v-layout row wrap justify-center>
        <v-flex xs11 sm11 md5 class="mt-3">
          <v-card tile flat color="transparent">
            <v-card-text class="subheading font-weight-light mb-3 textblue">Direkt herunterladen</v-card-text>
            <v-btn round outline @click="downloadAsPDF()" color="#3271b3" class="text-none"><v-icon left color="blue lighten-3" medium>fa-file-pdf-o</v-icon>Download PDF</v-btn>
            <v-btn round outline @click="downloadAsTIFF()" color="#3271b3" class="text-none"><v-icon left color="blue lighten-3" medium>fa-file-image-o</v-icon> Download TIFF</v-btn>
          </v-card>
        </v-flex>
        <v-flex xs11 sm11 md5 class="mt-3">
          <v-card tile flat color="transparent">
            <v-card-text class="subheading font-weight-light mb-3 textblue">Sichern im <span style="color:#3271b3">surf</span><span style="color:#71cbf4">and</span><span style="color:#3271b3">scan</span> Speicher</v-card-text>
            <v-btn round outline @click="saveToStorage()" color="#3271b3" class="text-none"><v-icon left color="blue lighten-3" medium>storage</v-icon> Speichern</v-btn>
          </v-card>
        </v-flex>
        <v-flex xs11 sm11 md5 class="mt-3">
          <v-card tile flat color="transparent">
            <v-card-text class="subheading font-weight-light mb-3 textblue">Sichern im <span style="color:#3271b3">einfach</span><span style="color:#71cbf4">Woohoo</span> Speicher</v-card-text>
            <v-btn round outline @click="updateToCloud()" color="#3271b3" class="text-none"><v-icon left color="blue lighten-3" medium>storage</v-icon> Hinzufügen</v-btn>
          </v-card>
        </v-flex>
      </v-layout>
     <!-- <v-layout style="margin-top: 20px;">
        <v-flex md6>
          <v-card-text class="subheading font-weight-light mb-3 textblue">
          Direkt herunterladen
          </v-card-text>
          <v-layout row align-start justify-start>
              <v-btn flat @click="downloadAsPDF()"><v-icon left color="blue lighten-3" medium>fa-file-pdf-o</v-icon>Download PDF</v-btn>
          </v-layout>
          <v-layout row>
              <v-btn flat @click="downloadAsTIFF()"><v-icon left color="blue lighten-3" medium>fa-file-image-o</v-icon> Download TIFF</v-btn>
          </v-layout>
        </v-flex>
        <v-flex md6>
          Sichern im SurfAndScan Speicher
          <v-layout row align-start justify-end>
            <v-btn flat @click="saveToStorage()"><v-icon left color="blue lighten-3" medium>storage</v-icon> Speichern</v-btn>
          </v-layout>
        </v-flex>
      </v-layout>-->
        <!--
        <v-card-text class="" style="font-size: 1.4em;">
          Sortierung anpassen
        </v-card-text>
        <v-layout row wrap justify-center abstandcardunten>
          <v-flex row d-flex md6 fluid>
            <mySortableDash :notClickable="false" ref="sortDash" :data="pageArray" :config="dashConfig"
                            :taskId="taskId" :host="wbHost"></mySortableDash>

          </v-flex>
        </v-layout>
        <!-->
        <br><br>
      </v-card>
      <!-- Ende Seite 4 -->
      </v-flex>
  </v-layout>
    </v-container>
  </div>
</template>

<script>
import FileDialog from './dialogs/FileDialog.vue'
import sas from 'surfandscan'
import mySortableDash from './../list/vue-sortable-dash.vue'
import MainToolbar from './../toolbar/MainToolbar'
import { SlickList, SlickItem } from 'vue-slicksort'
import { Container, Draggable } from 'vue-smooth-dnd'
import Vue from 'vue'
import DialogStatus from '../dialogs/DialogStatus'
// import mySortableDash from './../list/vue-simple-dash.vue'
export default {
  components: {DialogStatus, FileDialog, mySortableDash, MainToolbar, SlickList, SlickItem, Container, Draggable},
  name: 'page04',
  data () {
    return {
      wbHost: 'xxx',
      value: 0,
      fileName: null,
      categories: null,
      selectedCategories: [],
      scanStarted: false,
      messageCode: '',
      layout: [],
      message: '',
      taskId: '',
      dashConfig: {
        hasURLMaker: true,
        dashClass: 'marken',
        hasImage: true,
        hasText: true,
        link: '/PrintMedia/'
      },
      state: {
        onScan: false,
        value: 1,
        pages: 0,
        variant: 'success'
      },
      newItem: {
        completeFileName: '',
        created: 1557921626884,
        filename: '',
        name: 'Neues Dokument',
        guid: 73674024999324,
        listCategories: [],
        mimetype: 'application/pdf',
        size: 0,
        time: 1557921626884
      },
      pageArray: [],
      scanParameter: {
        duplex: false,
        feederUnit: -1
      },
      maxRows: 1,
      items: [
        {
          active: false,
          title: 'Was möchten Sie scannen?',
          subtitle: 'Mehrere Seiten'
        },
        {
          active: false,
          title: 'Einseitig oder Beidseitig?',
          subtitle: 'Beidseitig'
        },
        {
          active: false,
          title: 'Ihre Datei heißt:',
          subtitle: ''
        },
        {
          active: true,
          title: 'Herunterladen',
          subtitle: ''
        }
      ]
    }
  },
  methods: {
    startScan: function () {
      this.scanStarted = true
      console.log('startScan', this.scanParameter)
      sas.scan(this.scanParameter, this.onScanSuccess, this.onError)
    },
    onScanComplete (data) {
      console.log('onScanComplete', data)
    },
    onCloseFileDialog () {
      this.$router.push('/Search')
    },
    rotateItem (item) {
      console.log('rotateItem', item, this.layout)
      item.rotate = item.rotate + 90
    },
    deleteItem (item) {
      console.log('delete', item)
      this.layout.splice(this.layout.indexOf(item.pageNo), 1)
    },
    checkStatus () {
      console.log('check status', this.currentScanJob.id)
      sas.getTaskStatus(this.currentScanJob.id, this.onScanSuccess)
    },
    downloadAsPDF () {
      var filePattern = this.scanParameter.fileNamePattern
      var taskId = this.currentScanJob.id
      var pageOrder = this.getPageOrder()
      var rotateArr = this.getRotateArr()
      sas.downloadTaskAsPDF(taskId, filePattern, pageOrder, rotateArr)
    },
    onFileStore (data) {
      console.log('onFileStore', data)
    },
    getRotateArr () {
      let pages = []
      for (let i = 0; i < this.layout.length; i++) {
        pages.push(this.layout[i].rotate)
      }
      return pages
    },
    getPageOrder () {
      let pages = []
      for (let i = 0; i < this.layout.length; i++) {
        pages.push(this.layout[i].pageNo)
      }
      return pages
    },
    updateToCloud: function () {
      var taskId = ''
      if (this.currentScanJob != null) {
        taskId = this.currentScanJob.id
      }
      var filePattern = 'NewScanDocument'
      var name = 'Neues Dokument'
      var categories = ''
      var newCategories = []
      categories = newCategories.join(',')
      var headers = {
        'Authorization': 'BearerYourStuffHere',
        'AnyKey': 'AnyValueYouWant'
      }
      let uploadUrl = Vue.prototype.$dms.getCloudUploadUrl(window.location.origin)
      var params = {
        taskId: taskId,
        uploadTo: uploadUrl,
        groupFiles: 'true',
        name: name,
        filePattern: filePattern,
        categories: categories,
        pageOrder: this.getPageOrder().join(','),
        rotateArr: this.getRotateArr().join(',')
      }
      Vue.prototype.$api.showIdle()
      sas.uploadTaskToDestination(params, headers, this.onBlankFileStored)
    },
    saveBlankFileToStorage: function () {
      var taskId = ''
      if (this.currentScanJob != null) {
        taskId = this.currentScanJob.id
      }
      var filePattern = 'NewScanDocument'
      var name = 'Neues Dokument'
      var categories = ''
      var newCategories = []
      categories = newCategories.join(',')
      sas.saveTaskToStorage(taskId, name, filePattern, categories, this.getPageOrder(), this.getRotateArr(), this.onBlankFileStored)
    },
    onBlankFileStored (res) {
      console.log('onBlankFileStored', res)
      Vue.prototype.$api.hideIdle()
      let item = {}
      if (res.ok) {
        try {
          item = JSON.parse(res.message)
        } catch (e) {
          console.error(e)
        }
        this.$refs.fileDialog.open(item)
      } else {
        let d = {}
        d.messageTitle = 'Es ist ein Fehler aufgetreten (' + res.message + ')'
        d.success = false
        this.$refs.dlgStatus.open(d)
      }
    },
    saveToStorage () {
      this.saveBlankFileToStorage()
      /*
      var taskId = ''
      if (this.currentScanJob != null) {
        taskId = this.currentScanJob.id
      }
      this.newItem.targetDate = new Date().getTime()
      this.$refs.fileDialog.openAsNewFile(this.newItem, taskId, this.getPageOrder(), this.getRotateArr())
       */
    },
    updateOldPos () {
      for (let i = 0; i < this.layout.length; i++) {
        let l = this.layout[i]
        l.lastPos = {
          x: l.x,
          y: l.y
        }
        console.log(l)
      }
    },
    layoutUpdatedEvent (event) {
      console.log('movedEvent', event)
      let itemOutsideFound = false
      for (let i = 0; i < this.layout.length; i++) {
        let l = this.layout[i]
        if (l.y >= this.maxRows) {
          itemOutsideFound = true
        }
      }
      if (itemOutsideFound) {
        for (let i = 0; i < this.layout.length; i++) {
          let l = this.layout[i]
          l.x = l.lastPos.x
          l.y = l.lastPos.y
        }
      }
      this.updateOldPos()
    },
    downloadAsTIFF () {
      var filePattern = this.scanParameter.fileNamePattern
      var taskId = this.currentScanJob.id
      var pageOrder = this.getPageOrder()
      var rotateArr = this.getRotateArr()
      sas.downloadTaskAsTIFF(taskId, filePattern, pageOrder, rotateArr)
    },
    onScanSuccess (data) {
      console.log('onScanSuccess', data)
      this.state.onScan = true
      if (data) {
        this.currentScanJob = data
      }
      this.state.value = this.currentScanJob.progress
      this.state.pages = this.currentScanJob.pageNo
      this.pageArray = this.currentScanJob.files
      this.messageCode = ''
      if (this.currentScanJob.message) {
        this.messageCode = this.currentScanJob.messageCode
      }

      this.message = this.currentScanJob.message

      this.layout = []
      for (let i = 0; i < this.pageArray.length; i++) {
        var taskId = this.currentScanJob.id
        var fileId = this.pageArray[i].id
        this.pageArray[i].imageUrl = sas.getThumbnailUrl(fileId, taskId)
        this.layout.push({
          imageUrl: this.pageArray[i].imageUrl,
          taskId: taskId,
          rotate: 0,
          fileId: fileId,
          pageNo: this.layout.length
        })
      }
      this.updateOldPos()
      if (this.currentScanJob.status !== 'done') {
        window.setTimeout(this.checkStatus, 800)
      } else {
        this.onScanComplete(this.currentScanJob)
      }
    },
    startNewScan () {
      Vue.prototype.scanApi.setCurrentJob(null)
      this.$router.push('/page4')
    },
    backPage () {
      this.$router.push('/page4')
    },
    onGetCategories: function (data) {
      console.log('onGetCategories', data)
      this.categories = data.categories
      this.selectedCategories = this.scanParameter['categories']
    },
    onError (error, var1, var2) {
      console.log('onError', error, var1, var2)
      this.state.onScan = false
    },
    onDrop (dropResult) {
      console.log('dropResult', dropResult)
      this.layout = this.applyDrag(this.layout, dropResult)
      console.log('dropResult', dropResult)
    },
    applyDrag (arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    }
  },
  mounted () {
    if (Vue.prototype.$config.isCloud) {
      sas.setHost('https://localhost.surfandscan.com:8000')
    } else {
      if (location.protocol !== 'https:') {
        sas.setHost('http://localhost.surfandscan.com:8001')
      } else {
        sas.setHost('https://localhost.surfandscan.com:8000')
      }
    }
    this.scanParameter = Vue.prototype.scanApi.getScanParameter()
    this.selectedCategories = null
    this.fileName = this.scanParameter.fileNamePattern
    this.pageArray = Vue.prototype.scanApi.getPages()
    this.currentScanJob = Vue.prototype.scanApi.getCurrentJob()
    // Vue.prototype.$dms.getStorageCategories(this.onGetCategories)
    if (this.currentScanJob != null) {
      this.taskId = this.currentScanJob.id
    } else {
      this.taskId = 'demo'
      this.scanParameter = {
        fileName: ''
      }
      this.currentScanJob = {
        id: 'demo',
        files: [ {
          fileName: 'demo.jpg'
        }]
      }
    }
    this.checkStatus()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PageDownload.vue